import React from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Hero = () => {
  return (
    <>
    <Navbar />
    <section
          className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 text-white overflow-hidden"
      >
          {/* Background Decorative Circles */}
          <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-white opacity-10 rounded-full blur-3xl" />
          <div className="absolute bottom-0 right-0 w-[300px] h-[300px] bg-white opacity-10 rounded-full blur-2xl" />

          <div className="max-w-7xl mx-auto px-6 py-32 flex flex-col md:flex-row items-center justify-between">
              {/* Left Text Area */}
              <motion.div
                  initial={{ x: -50, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 1 }}
                  className="text-center md:text-left z-10"
              >
                  <h1 className="text-5xl md:text-6xl font-extrabold leading-tight mb-4 text-yellow-700">
                      <p className="mt-4 text-4xl text-white max-w-xl">
                          مكان للعلم، والأخلاق، والتميّز.
                      </p>
                      Welcome to <span className="text-yellow-300">Ddikroo College</span>
                  </h1>
                  <p className="text-xl text-gray-200 max-w-xl mb-6">
                      Shaping young minds with a balanced blend of Islamic and Western education to build tomorrow's leaders.
                  </p>
                  <div className="flex justify-center md:justify-start gap-4">
                      <a
                          href="#about"
                          className="bg-yellow-400 text-blue-900 font-semibold px-6 py-3 rounded-lg shadow hover:bg-yellow-300"
                      >
                          Learn More
                      </a>
                      <a
                          href="#admission"
                          className="bg-white text-blue-800 font-semibold px-6 py-3 rounded-lg shadow hover:bg-gray-200"
                      >
                          Enroll Now
                      </a>
                  </div>
              </motion.div>

              {/* Right Side Illustration */}
              <motion.div
                  initial={{ x: 50, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 1 }}
                  className="mt-10 md:mt-0 w-full md:w-1/2 z-10"
              >
                  <img
                      src="/images/school-hero-illustration.png" // Replace with your own image
                      alt="Hero Illustration"
                      className="w-full max-w-md mx-auto drop-shadow-xl" />
              </motion.div>
          </div>
      </section><section className="bg-white py-20 px-6 md:px-20 text-gray-800">
              <div className="max-w-6xl mx-auto text-center">
                  <h2 className="text-4xl font-bold mb-6">
                      About <span className="text-yellow-500">Ddikroo College</span>
                  </h2>
                  <p className="text-lg leading-7 max-w-3xl mx-auto">
                      Ddikroo College is a center of excellence where Islamic and modern education are combined to raise students who are morally upright, academically sound, and spiritually grounded.
                  </p>
                  <div className="mt-10 grid md:grid-cols-3 gap-8">
                      <div className="p-6 border rounded-xl shadow hover:shadow-lg transition">
                          <h3 className="text-2xl font-semibold mb-3">Our Vision</h3>
                          <p>
                              To be a leading Islamic institution nurturing global citizens rooted in faith and knowledge.
                          </p>
                      </div>
                      <div className="p-6 border rounded-xl shadow hover:shadow-lg transition">
                          <h3 className="text-2xl font-semibold mb-3">Our Mission</h3>
                          <p>
                              To provide high-quality, balanced education combining Quranic teachings with 21st-century skills.
                          </p>
                      </div>
                      <div className="p-6 border rounded-xl shadow hover:shadow-lg transition">
                          <h3 className="text-2xl font-semibold mb-3">Core Values</h3>
                          <ul className="list-disc text-left pl-5">
                              <li>Integrity</li>
                              <li>Discipline</li>
                              <li>Knowledge</li>
                              <li>Compassion</li>
                          </ul>
                      </div>
                  </div>
              </div>
          </section>
          <section className="bg-gray-100 py-20 px-6 md:px-20 text-gray-900">
  <div className="max-w-6xl mx-auto text-center">
    <h2 className="text-4xl font-bold mb-4">
      Get in <span className="text-yellow-500">Touch</span>
    </h2>
    <p className="text-lg mb-10">
      We'd love to hear from you. Reach out via any method below or use the contact form.
    </p>

    <div className="grid md:grid-cols-3 gap-8 text-left mb-16">
      <div>
        <h3 className="text-xl font-semibold mb-2">📍 Address</h3>
        <p>Along Emir Road, Ilorin, Kwara State, Nigeria</p>
      </div>
      <div>
        <h3 className="text-xl font-semibold mb-2">📞 Phone</h3>
        <p>+234 800 123 4567</p>
        <p>+234 701 234 5678</p>
      </div>
      <div>
        <h3 className="text-xl font-semibold mb-2">✉️ Email</h3>
        <p>info@ddikroocollege.sch.ng</p>
        <p>admissions@ddikroocollege.sch.ng</p>
      </div>
    </div>

    {/* Contact Form */}
    <form className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto text-left">
      <input
        type="text"
        placeholder="Full Name"
        className="p-3 rounded-md border border-gray-300 focus:ring focus:outline-none"
      />
      <input
        type="email"
        placeholder="Email Address"
        className="p-3 rounded-md border border-gray-300 focus:ring focus:outline-none"
      />
      <textarea
        placeholder="Your Message"
        rows={5}
        className="p-3 rounded-md border border-gray-300 focus:ring focus:outline-none md:col-span-2"
      ></textarea>
      <button
        type="submit"
        className="bg-yellow-500 text-white font-semibold py-3 px-6 rounded-md hover:bg-yellow-600 transition md:col-span-2"
      >
        Send Message
      </button>
    </form>
  </div>
</section>
<section className="py-20 px-6 md:px-20 bg-white text-gray-900">
  <div className="max-w-6xl mx-auto text-center">
    <h2 className="text-4xl font-bold mb-4">
      Our <span className="text-yellow-500">Programs</span>
    </h2>
    <p className="text-lg mb-10">
      Ddikroo College offers well-structured academic programs to build strong character and academic excellence.
    </p>

    <div className="grid md:grid-cols-3 gap-10 text-left">
      {/* Islamic Studies */}
      <div className="bg-gray-50 p-6 rounded-lg shadow hover:shadow-lg transition">
        <h3 className="text-2xl font-semibold text-yellow-500 mb-3">🕌 Islamic Studies</h3>
        <p>
          Our Islamic program provides a deep understanding of the Qur'an, Hadith, and Arabic language alongside moral education.
        </p>
      </div>

      {/* Science Department */}
      <div className="bg-gray-50 p-6 rounded-lg shadow hover:shadow-lg transition">
        <h3 className="text-2xl font-semibold text-yellow-500 mb-3">🔬 Science Department</h3>
        <p>
          Offering top-tier education in Biology, Physics, Chemistry, and Mathematics with practical lab sessions.
        </p>
      </div>

      {/* Arts & Humanities */}
      <div className="bg-gray-50 p-6 rounded-lg shadow hover:shadow-lg transition">
        <h3 className="text-2xl font-semibold text-yellow-500 mb-3">📚 Arts & Humanities</h3>
        <p>
          Subjects like Literature, Government, CRS, and Civic Education that develop critical thinking and creativity.
        </p>
      </div>

      {/* Commercial Department */}
      <div className="bg-gray-50 p-6 rounded-lg shadow hover:shadow-lg transition md:col-span-1">
        <h3 className="text-2xl font-semibold text-yellow-500 mb-3">💼 Commercial Studies</h3>
        <p>
          Courses include Accounting, Commerce, Economics, and Marketing – preparing students for business success.
        </p>
      </div>
    </div>
  </div>
</section>
<Footer />          
          </>

  );
};

export default Hero;
